import React, { useState, useEffect } from 'react';
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'
import $ from 'jquery'
export default function Add_member() {
  const navigate = useNavigate();
  const [blockIds, setBlockIds] = useState([]);
  const [roles, setRoles] = useState([]);
  const [memberNumber, setMemberNumber] = useState(0);
  const [memberLimitReached, setMemberLimitReached] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  var memcounter = 0;
  // Create the first block on page load
  useEffect(() => {
    setBlockIds(['block1']);
  }, []);

  useEffect(() => {

    const company_id = localStorage.getItem('mem_company_id');
    const maxMembers = parseInt(localStorage.getItem('max_member')) || 0;

    fetch('getNumberOfMember.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        companyId: company_id
      })
    })
      .then(response => response.json())
      .then(result => {

        if (result.status === 'success') {

          const currentMembers = parseInt(result.member_count);

          setMemberNumber(currentMembers);

          if (currentMembers >= maxMembers) {
            setMemberLimitReached(true);
          } else {
            setMemberLimitReached(false);
          }

        } else {
          console.warn(result.message);
        }

      })
      .catch(error => {
        console.error(error);
      });

  }, []);

  useEffect(() => {
    const company_id = localStorage.getItem('mem_company_id');

    fetch('getAllDefaultroles.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({
        companyId: company_id
      })
    })
      .then(response => response.json()) // matches PHP json_encode($data)
      .then(result => {
        if (Array.isArray(result)) {
          setRoles(result);
        } else {
          console.warn("Unexpected response:", result);
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
      });

  }, []);

  // Add new block when clicking "Add+"
  const handleAddBlock = () => {
    const nextIdNumber = blockIds.length + 1;
    const newId = `block${nextIdNumber}`;
    setBlockIds(prev => [...prev, newId]);
  };

  // Save button click
  const handleSave = () => {
    console.log('Block IDs:', blockIds);
    var len = blockIds.length;
    if (len > 0) {
      if (memcounter < len) {
        var trgblock = blockIds[memcounter];
        savemember(trgblock);
        updateLoader(memcounter, len)
        memcounter++;
      } else {
        document.getElementById('loaderpops').classList.remove('activDisplay')
        showAlert('Your team created successfully.');
        setTimeout(redirect, 1500)

      }
    } else {
      showAlert("Insert member's data please.");
    }
    // You can loop through blockIds and fetch inputs from each block to send to DB
  };

  function updateLoader(countmem, totallen) {
    document.getElementById('loaderpops').classList.add('activDisplay')
    var trglen = (countmem / totallen) * 100;
    document.getElementById('loader_bar').style.width = trglen + '%';

  }

  function redirect() {
    navigate('/projectlist');
  }


  function savemember(trgid) {
    console.log(trgid)
    var mem_first_name = $('#' + trgid + ' #memFirstName').val();
    var mem_last_name = $('#' + trgid + ' #memLastName').val();
    var mememail = $('#' + trgid + ' #memEmailAdd').val();
    var memcategory = $('#' + trgid + ' #member_type').val();
    var memcategoryText = $('#' + trgid + ' #member_type option:selected').text();

    if (mem_first_name === '') {
      showAlert('Please insert the member first name.');
    } else if (mem_last_name === '') {
      showAlert('Please insert the member last name.');
    } else if (mememail === '') {
      showAlert('Please insert the member email.');
    } else {
      var company_id = localStorage.getItem('mem_company_id');
      var comname = localStorage.getItem('mem_company_name');
      var memberimg = 'profile_imgs/no-image-icon-32.jpg';
      var companyimg = localStorage.getItem('companylogo');
      var obj = {
        mem_account_status: 'not_complete',
        mem_email: mememail,
        password: '',
        country: '',
        expertise: '',
        mem_skills: '',
        mem_com_id: company_id,
        mem_role: memcategoryText,
        mem_position: memcategory,
        company_name: comname,
        fname: mem_first_name,
        lname: mem_last_name,
        activation: 'no',
        memberimg: memberimg,
        companyimg: companyimg
      };

      console.log(obj);

      fetch('memberListingsignup.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams(obj)
      })
        .then(response => response.text()) // IMPORTANT (not json)
        .then(result => {
          console.log(result);

          if (result !== 'Mail Exist') {
            sendEmailToUser(result, mememail);
          } else {
            showAlert(mememail + ' the EMAIL you enter already in use.');
            handleSave();
          }
        })
        .catch(error => {
          console.error("Fetch Error:", error);
        });
    }

  }

  function sendEmailToUser(mid, memail) {
    var memid = mid;
    var mememail = memail;
    var memid = mid;
    var comname = localStorage.getItem('mem_company_name');
    var companyemail = localStorage.getItem('useremail');

    var obj = {
      memid: memid,
      mememail: mememail,
      comname: comname,
      companyemail: companyemail
    };

    console.log(obj);

    fetch('addmember_user_email.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams(obj)
    })
      .then(response => response.text()) // IMPORTANT: text(), not json()
      .then(result => {
        console.log("Response:", result);

        // Check success based on your PHP response
        if (result.includes('Success')) {
          handleSave();
        } else {
          alert('Cannot create account. Please try again.');
        }
      })
      .catch(error => {
        console.error("Fetch Error:", error);
        alert('Server error occurred. Check console for details.');
      });
  }

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

  return (
    <div>
      <Topbar toggleSidebar={toggleSidebar} />
    <Sidebar_component sidebarOpen={sidebarOpen} />
      <div className='vl_dsh_bodypart'>
        <div className='vl_dsh_one_full'>
          <div className='vl_dsh_header_bar'>
            <h2>Create Team For your company</h2>
            <div className='vl_dsh_addbtnholder'>
              <button className='plusbutton' onClick={handleAddBlock} disabled={memberLimitReached}>Add+</button>
            </div>
          </div>
        </div>
        <div className='vl_dsh_one_full'>
          {
            memberLimitReached ? (

              <div className="member_limit_message">
                <h3>Member Limit Reached</h3>

                <p>
                  You have already used all available member slots included in your
                  current subscription plan.
                </p>

                <p>
                  Current Members: {memberNumber}
                </p>

                <p>
                  Allowed Members: {localStorage.getItem('max_member')}
                </p>

                <p>
                  To add more team members, please upgrade your subscription plan
                  or deposit additional subscription fees according to the number
                  of additional members you require.
                </p>
              </div>

            ) : (

              <div className='add_container'>
                <div className='add_block_list' id="mem_rec_list">

                  {blockIds.map((blockId) => (
                    <div className="add_block" id={blockId} key={blockId}>
                      <div className="formfield">
                        <label>First Name</label>
                        <input type="text" id="memFirstName" />
                      </div>

                      <div className="formfield">
                        <label>Last Name</label>
                        <input type="text" id="memLastName" />
                      </div>

                      <div className="formfield">
                        <label>Email Address</label>
                        <input type="email" id="memEmailAdd" />
                      </div>

                      <div className="formfield">
                        <label>Category</label>

                        <select id="member_type">
                          <option value="">Select Role</option>

                          {roles.map((role) => (
                            <option
                              key={role.primary_key}
                              value={role.primary_key}
                            >
                              {role.role_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  ))}

                </div>

                <div className='add_block noborder'>
                  <button className='savebtn' onClick={handleSave}>
                    Save
                  </button>

                  <button
                    className='plusbutton'
                    onClick={handleAddBlock}
                  >
                    Add+
                  </button>
                </div>
              </div>

            )
          }
        </div>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
      <div className='loaderpop' id="loaderpops">
        <div className='preloader_base'>
          <div className='preloader_inner' id="loader_bar">&nbsp;</div>
        </div>
      </div>
    </div>
  )
}